import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import {
  bulkOperationsMutationKeys,
  bulkOperationsQueryKeys
} from '../constants'
import { customQueryClient } from '../../config/query-client'

export const useAddBulkPinsToGroupMutation = (options) => {
  const handleMutation = async ({ groupIds, source }) => {
    const config = {
      method: 'post',
      data: {
        groupIds,
        source
      }
    }

    const { data } = await api('/api/v2/bulk/groups/pins', config)
    return data
  }

  const invalidTrackOperationQuery = (mutationParams) => {
    const { projectId } = mutationParams.source
    customQueryClient.invalidateQueries({
      queryKey: [bulkOperationsQueryKeys.BULK_TRACK_OPERATIONS_LIST, projectId]
    })
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: bulkOperationsMutationKeys.ADD_BULK_PINS_TO_GROUP,
    retry: 0,
    ...options,
    onSuccess: (data, mutationParams, context) => {
      invalidTrackOperationQuery(mutationParams)
      options.onSuccess?.(data, mutationParams, context)
    }
  })
}
